import CrossIcon from 'components/Icons/DangerIcon';
import Loader from 'components/Loader';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryBatchFilterMobile } from '../HistoryBatchFilterMobile';
import { HistoryBatchStatusMobile } from '../HistoryBatchStatusMobile';

const HistoryMobile = () => {
  const { batchFiles, loading, isLastPage, showMore } = useHistoryBatch();

  const { t } = useTranslation(['history']);

  useEffect(() => {
    document.body.classList.remove('unscrollable');
  }, []);

  if (loading) return <Loader />;

  const hasMoreThanTenItems = batchFiles?.length >= 10;

  const isVisibleButtonShowMore = hasMoreThanTenItems && !isLastPage;

  return (
    <div className="beneficiaries-history">
      <div className="refresh-page-mobile">
        <CrossIcon />
        <span>{t('attention')}</span>
      </div>
      <div className="history-mobile">
        <HistoryBatchFilterMobile />
        {batchFiles?.map((file, index) => (
          <HistoryBatchStatusMobile file={file} key={file.id} index={index} />
        ))}
        {isVisibleButtonShowMore && (
          <div className="button-wrapper" data-testid="show-more">
            <button className="show-more-button" type="button" onClick={showMore}>
              {t('beneficiaries:show_more')}
              <span className="chevron" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryMobile;
